<template>
  <SearchLayout :kind="layout">
    <div class="tabs is-fullwidth is-boxed">
      <ul>
        <router-link
          tag="li"
          :to="{ name: 'Search' }"
          icon="fa-align-left"
          active-class="is-active"
          exact
          ><a>Text <b-icon icon="align-left" size="is-small"> </b-icon></a
        ></router-link>
        <router-link
          tag="li"
          :to="{ name: 'Tags' }"
          icon="fa-tags"
          active-class="is-active"
          exact
          ><a>Tags <b-icon icon="tags" size="is-small"> </b-icon></a
        ></router-link>
         <!-- <router-link
          tag="li"
          :to="{ name: 'Metadata' }"
          icon="fa-database"
          active-class="is-active"
          exact
          ><a>Metadata <b-icon icon="meta" size="is-small"> </b-icon></a
        ></router-link> -->
      </ul>
    </div>
    <template #sidebar>
      <SearchSidebar>
        <SearchFacets />
      </SearchSidebar>
    </template>

    <header style="margin-bottom: 0.75rem;">
      <div v-if="total > 0" style="margin-bottom: 0.75rem">
        <strong>{{ total }} {{ $t("Tags found") }}</strong>
      </div>
      <b-pagination
        v-if="pagesTotal > 1"
        :total="total"
        :current.sync="currentPage"
        :range-before="3"
        :range-after="4"
        order="is-right"
        :per-page="itemsPerPage"
        icon-prev="chevron-left"
        icon-next="chevron-right"
      />
    </header>
    <TagSearchForm style="margin-bottom: 0.75rem"></TagSearchForm>

    <div class="columns">
      <!-- <div class="column">
         <TagSearchForm style="margin-bottom: 0.75rem"></TagSearchForm>
      </div> -->
      <div class="column">
        <b-field :label="$t('Tag Type')">
          <b-taginput
            v-model="tags"
            :data="filteredTags"
            autocomplete
            :open-on-focus="true"
            :allow-duplicates="false"
            ref="taginput"
            :placeholder="$t('Tag Type')"
            @typing="getFilteredTags"
          >
            <template slot-scope="props">
              <strong>{{ $t(props.option.value) }}</strong> ({{
                props.option.count
              }})
            </template>
            <template slot="empty">
              There are no items
            </template>
            <template slot="selected" slot-scope="props">
              <b-tag
                v-for="(tag, index) in props.tags"
                :key="index"
                :type="getType(tag)"
                rounded
                :tabstop="false"
                ellipsis
                closable
                @close="$refs.taginput.removeTag(index, $event)"
              >
                {{ tag.value }}
              </b-tag>
            </template>
          </b-taginput>
        </b-field>
      </div>

      <!-- <div v-if="tags.length > 0" class="column">
        <b-collapse
          :open="false"
          style="margin-top: 1.5rem"
          class="card"
          animation="slide"
        >
          <div
            slot="trigger"
            slot-scope="props"
            class="card-header"
            role="button"
          >
            <p class="card-header-title">
              {{ $t("Attributes") }}
            </p>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'caret-down' : 'caret-up'"> </b-icon>
            </a>
          </div>
          <div class="card-content">
            <div class="content">
              <div
                class="column"
                v-for="attribute in attributes"
                :key="attribute.label"
              >
                <div v-if="attribute.items.length > 0">
                  <StringFilter
                    :label="$t(getLabel(attribute.label))"
                    :items="attribute.items"
                    :name="attribute.label"
                  />
                </div>
                <div v-else>
                  <b-dropdown disabled aria-role="list">
                    <button class="button" slot="trigger">
                      <span>{{ $t(getLabel(attribute.label)) }}</span>
                      <b-icon icon="menu-down"></b-icon>
                    </button>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div> -->
    </div>
    <div class="columns">
      <div
        class="column"
        v-for="attribute in attributes"
        :key="attribute.label"
      >
        <b-button
          v-if="attribute.items.length > 0"
          icon-left="filter"
          @click="openModal(attribute)"
          >{{ $t(attribute.label) }}</b-button
        >
        <b-button
          v-else
          disabled
          icon-left="filter"
          @click="openModal(attribute)"
          >{{ $t(attribute.label) }}</b-button
        >
      </div>
    </div>

    <div v-show="!isLoading && total === 0" class="message is-dark">
      <div class="message-body">
        {{ $t("No results for") }}
        <strong class="is-italic">{{ query.value }}</strong>
      </div>
    </div>

    <SearchResultList>
      <SearchResultListItem
        v-for="(searchResult, index) in results"
        :key="index"
        :route="searchResultRoutes[index]"
        style="margin-bottom: 0.75rem"
      >
        <template #header>
          {{ searchResult.title }} - {{ $t("Page") }}
          {{ searchResult.pageNr }}
        </template>
        <span>
          {{ searchResult.context_before }}
        </span>
        <b-tag v-if="searchResult.value[1]" :type="tagColor(searchResult.type)"
          >{{ searchResult.value[0] }} {{ searchResult.value[1] }}
        </b-tag>
        <b-tag v-else :type="tagColor(searchResult.type)">{{
          searchResult.value[0]
        }}</b-tag>
        <span>
          {{ searchResult.context_after }}
        </span>
      </SearchResultListItem>
    </SearchResultList>

    <SearchResult></SearchResult>
  </SearchLayout>
</template>

<script>
import SearchLayout from "@/components/SearchLayout.vue";
import SearchSidebar from "@/components/SearchSidebar.vue";
import SearchFacets from "@/components/SearchFacets.vue";
import TagSearchForm from "@/components/TagSearchForm.vue";
import SearchResult from "@/components/SearchResult.vue";
import StringFilter from "@/components/Filter/StringFilter.vue";
import SearchResultList from "@/components/SearchResultList.vue";
import SearchResultListItem from "@/components/SearchResultListItem.vue";
import SearchResultSnippet from "@/components/SearchResultSnippet.vue";

import StringFilterModal from "@/components/Filter/StringFilterModal.vue";

import { createMapper } from "@/utils/mapping.js";

import { debounce } from "@/utils/misc.js";

import config from "@/config.json";

const mapper = createMapper("tagsearch-form");

export default {
  components: {
    SearchLayout,
    SearchSidebar,
    SearchFacets,
    TagSearchForm,
    SearchResult,
    StringFilter,
    SearchResultList,
    SearchResultListItem,
    SearchResultSnippet,
    StringFilterModal,
  },
  watch: {
    activeTab() {
      this.$router.push({ query: {} });
    },
    currentPage: {
      handler: function() {
        const query = { ...this.$route.query };
        query[mapper.toURL("page")] = this.currentPage;
        console.log(query);
        this.$router.push({ query });
      },
    },
    tags: {
      handler: function() {
        const query = { ...this.$route.query };
        let typeArray = this.tags.map(function(obj) {
          if (obj != null) {
            return obj.value;
          }
        });
        typeArray = typeArray.filter(function(el) {
          return el != null;
        });
        query[mapper.toURL("type")] = typeArray;
        this.$router.push({ query });
      },
    },
    "$route.query": {
      handler: "update",
      // NOTE: should NOT run before children's watchers
      immediate: true,
    },
  },
  data() {
    return {
      activeTab: 0,
      isOpen: false,
      facets: [],
      facetValues: [],
      isLoading: false,
      tags: [],
      results: null,
      currentPage: 1,
      currentTypes: [],
      itemsPerPage: 10,
      total: NaN,
      filteredTags: [],
      attributes: [],
      confAttr: config.attributes,
    };
  },
  async mounted() {
    await this.load();
  },
  computed: {
    layout() {
      const { term } = this.query;
      return !term ? "narrow" : "sidebar";
    },
    query() {
      return mapper.fromURL(this.$route.query);
    },
    pagesTotal() {
      return Math.ceil(this.total / this.itemsPerPage);
    },
    searchResultRoutes() {
      return this.results.map((result) => ({
        name: "Browser",
        params: {
          documentId: result.dId,
          pageNum: result.pageNr,
        },
        query: mapper.toURL({
          term: result.value.join(''),
        }),
      }));
    },
    offset() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    limit() {
      return this.itemsPerPage;
    },
    params() {
      return { offset: this.offset, limit: this.limit };
    },
  },
  methods: {
    load: debounce(async function() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      const { total, results, facets } = await this.fetchNextPage();
      this.facetValues = [];
      this.results = results;
      this.facets = facets;
      this.filteredTags = facets.type;
      this.setAttributes(facets);

      if (this.tags.length == 0 && typeof this.query["type"] != null) {
        const result = this.facets.type.find(
          (type) => type.value === this.query["type"]
        );
        if (typeof result !== "undefined" && result !== null) {
          this.tags.push(result);
        }
      }

      this.total = total;
      this.isLoading = false;
    }, 50),
    update(query, prevQuery = {}) {
      let mustReload = false;
      let mustResetPage = true;
      let mustReset = false;

      if (query["v"] != prevQuery["v"]) {
        mustReload = true;
      }

      if (query["type"] != prevQuery["type"]) {
        mustReload = true;
      }

      if (query["p"] != prevQuery["p"]) {
        mustReload = true;
        mustResetPage = false;
      }

      for (var i = 0; i < config.attributes.length; i++) {
        var field = config.attributes[i].field;
        this.facetValues.push({ value: query[field], field: field });
        mustReload = true;
      }

      if (mustReload) {
        this.load();
      }
    },
    setAttributes(facets) {
      let arr = [];
      for (const [key, value] of Object.entries(facets)) {
        if (key !== "type") {
          if(this.$route.query[key]){
            arr.push({ items: value, label: this.$route.query[key], name: key });
            // arr.push({ items: value, label: key });
          }else{
            arr.push({ items: value, label: key, name: key });
          }
        }
      }
      this.attributes = arr;
    },
    getLabel(field) {
      var label = field.replace("cA_", "");
      return label.charAt(0).toUpperCase() + label.slice(1);
    },
    resetPage() {
      this.$router.push({
        query: omit(this.$route.query, this.QUERY.PAGE),
      });
    },
    reset() {
      this.$router.push({
        query: omit(this.$route.query, [this.QUERY.TERM, this.QUERY.PAGE]),
      });

      this.results = null;
    },
    scroll() {
      this.$nextTick(() => (document.documentElement.scrollTop = 0));
    },
    getFilteredTags(text) {
      this.filteredTags = this.facets.filter((option) => {
        return (
          option.value
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        );
      });
    },
    openModal(attribute) {
      console.log(attribute)
      var modal = this.$buefy.modal.open({
        parent: this,

        component: StringFilterModal,
        events: {
          closeModal: (value) => {
            modal.close();
          },
        },
        trapFocus: true,
        destroyOnHide: false,
        props: {
          items: attribute.items,
          name: attribute.name,
          label: attribute.label,
        },
      });
    },

    tagColor(value) {
      return "is-" + value;
    },
    getType(tag) {
      return "is-" + tag.value;
    },
    async fetchNextPage() {
      if (this.error !== null) {
        this.error = null;
      }
      let attributesarr = this.confAttr.map((a) => a.field);
      attributesarr.push("type");
      this.facetValues = this.facetValues.filter(function(element) {
        return element.value !== undefined;
      });
      try {
        return await this.api.fetchTagResults(
          {
            ...this.query,
            facets: attributesarr,
            facetValues: this.facetValues,
          },
          this.params
        );
      } catch (err) {
        this.error = err.message;
      }
    },
  },
};
</script>
